/* eslint-disable import/no-cycle */
import { PENDING_USERS, RESEND_INVITATION } from "lib/constants";
import { getAPICall, putAPICall } from "../lib/callApi";

export const fetchPendingUsersList = async (payload) => {
  const data = await getAPICall(PENDING_USERS, true, payload);
  return data;
};

export const resendInvitation = async (userId, payload) => {
  const data = await putAPICall(`${RESEND_INVITATION}/${userId}`, true, payload);
  return data;
};
